import axios from 'axios'

const url = process.env.VUE_APP_API_URL

const create = async (resource, data) => {
  const request = {
    method: "POST",
    url: url + `/${resource}`,
    headers: { authorization: `Bearer ${localStorage.getItem("idToken")}` },
    data
  }

  try {
    const response = await axios(request)
    return response.data
  } catch (err) {
    const error = {
      code: err.code || "",
      message: err.message || "",
      status: err.status || 500
    }
    throw error
  }
}

const read = async (resource, id) => {
  const request = {
    method: "GET",
    url: url + `/${resource}/${id}`,
    headers: { authorization: `Bearer ${localStorage.getItem("idToken")}` }
  }

  try {
    const response = await axios(request)
    return response.data
  } catch (err) {
    const error = {
      code: err.response.code || "",
      message: err.response.message || "",
      status: err.status || 500
    }
    throw error
  }
}

const update = async (resource:string, id:string, data:{old:any, new:any}) => {
  const request = {
    method: "PATCH",
    url: url + `/${resource}/${id}`,
    headers: { authorization: `Bearer ${localStorage.getItem("idToken")}` },
    data
  }

  try {
    const response = await axios(request)
    return response.data
  } catch (err) {
    const error = {
      code: err.response.code || "",
      message: err.response.message || "",
      status: err.status || 500
    }
    throw error
  }
}

const remove = async (resource:string, id:string) => {
  const request = {
    method: "DELETE",
    url: url + `/${resource}/${id}`,
    headers: { authorization: `Bearer ${localStorage.getItem("idToken")}` },
  }

  try {
    const response = await axios(request)
    return response.data
  } catch (err) {
    const error = {
      code: err.response.code || "",
      message: err.response.message || "",
      status: err.status || 500
    }
    throw error
  }
}

export default {
  install(Vue) {
    Vue.prototype.$api = { create, read, update, remove }
  }
}
